import { render, staticRenderFns } from "./VirtualScrollTableNew.vue?vue&type=template&id=77274f1a&scoped=true"
import script from "./VirtualScrollTableNew.vue?vue&type=script&lang=js"
export * from "./VirtualScrollTableNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77274f1a",
  null
  
)

export default component.exports